"use client";
import {
  Image_default
} from "./chunk-KBWHYFNM.mjs";
import {
  Button_default
} from "./chunk-WBZIOSC6.mjs";
import {
  Icon_default
} from "./chunk-KJNGPZGH.mjs";

// src/components/sections/MachineAdvantage/MachineAdvantage.tsx
import { forwardRef } from "react";
import { useResponsiveQuery } from "atomic-layout";
import { jsx, jsxs } from "react/jsx-runtime";
import { createElement } from "react";
var MachineAdvantage = forwardRef(
  function MachineAdvantage2({ title, image, cards, buttons, onClick, containerBackground, referId }, ref) {
    const isMobile = useResponsiveQuery({ to: "sm" });
    return /* @__PURE__ */ jsx(
      "div",
      {
        ref,
        id: referId,
        className: "flex justify-center items-center py-40 lg:py-80 px-24",
        children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col justify-center items-center w-full max-w-[455px] md:max-w-[1060px]", children: [
          /* @__PURE__ */ jsx("h2", { className: "mb-16 md:mb-40 font-display text-3xl lg:text-4xl font-bold leading-7 lg:leading-8 text-center md:text-left", children: title }),
          image && /* @__PURE__ */ jsx(
            "div",
            {
              className: `flex relative justify-center items-center p-40 w-full md:h-[380px] lg:h-auto ${containerBackground} rounded-2xl`,
              children: /* @__PURE__ */ jsx(
                Image_default,
                {
                  src: image.path,
                  width: 425,
                  height: 290,
                  alt: image.alternativeText,
                  layout: isMobile ? "responsive" : "intrinsic",
                  className: " object-contain"
                }
              )
            }
          ),
          /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-16 md:gap-40 justify-center mt-16 md:mt-40", children: cards == null ? void 0 : cards.map(({ id, icon, title: title2, description }) => /* @__PURE__ */ jsxs(
            "div",
            {
              className: "flex flex-col xxs:flex-[calc(50%-16px)] w-full md:max-w-[calc(30%-16px)]",
              children: [
                /* @__PURE__ */ jsx(
                  Icon_default,
                  {
                    name: icon.name,
                    className: "text-stone-500 fill-current w-40 h-40"
                  }
                ),
                /* @__PURE__ */ jsx("p", { className: "my-8 font-display text-xl md:text-2xl font-bold leading-5 md:leading-6", children: title2 }),
                /* @__PURE__ */ jsx("p", { className: "md:text-base text-sm", children: description })
              ]
            },
            id
          )) }),
          /* @__PURE__ */ jsx("div", { className: "flex justify-center items-center mt-16 w-full", children: buttons == null ? void 0 : buttons.map((buttonProps, index) => /* @__PURE__ */ createElement(Button_default, { ...buttonProps, key: index, onClick })) })
        ] })
      }
    );
  }
);
var MachineAdvantage_default = MachineAdvantage;

export {
  MachineAdvantage_default
};
